import { UndefinedAble } from "data/base";
import { AppConfig } from "data/terra/AppConfig";
import { Environment } from "data/terra/Environment";
import { t } from "helpers/i18n";

export const getActiveEnv = (appConfigs: AppConfig[], environments?: Environment[]): UndefinedAble<Environment> => {
    let env = appConfigs.find((c: AppConfig) => c.isActive)?.env;
    if (environments) {
        return environments.find((e: Environment) => e.id === env?.id)
    } else {
        return env
    }
}

export const isEnvActiveEnv = (env: Environment, appConfigs: AppConfig[]): boolean => {
    return getActiveEnv(appConfigs)?.id === env.id
}

export const getEnvDisplayName = (env: Environment, appConfigs: AppConfig[]): string => {
    if (isEnvActiveEnv(env, appConfigs)) {
        return `${env.name.toUpperCase()} (${t('default')})`;
    } else {
        return env.name.toUpperCase();
    }
}
  